import Hls from 'hls.js';
import { HLS_SUPPORT } from '@videotools/js/components/player/enums';

const HLS_EVENT = Hls.Events;

const getSeekPosition = (position, timeOffset, internalDuration) => {
	let seekPosition = 0;

	if (seekPosition < 0) {
		seekPosition = internalDuration + position + timeOffset;
	} else {
		seekPosition = position + timeOffset;
	}

	if (seekPosition > internalDuration) {
		seekPosition = internalDuration;
	}

	return seekPosition;
};

const seek = (videoEl, position) => {
	if (!videoEl) return;
	videoEl.currentTime = position;
};

const load = (videoEl, url, hlsOptions) => {
	const hlsSupport = getHlsSupport();

	// HLS
	if (hlsSupport === HLS_SUPPORT.SUPPORTED_MSE) {
		const hls = new Hls(hlsOptions);

		hls.attachMedia(videoEl);
		hls.on(HLS_EVENT.MEDIA_ATTACHED, () => {
			hls.loadSource(url);
		});

		return hls;
	} else if (hlsSupport === HLS_SUPPORT.SUPPORTED_NATIVE) {
		videoEl.src = url;
	} else {
		throw new Error('HLS is not supported');
	}

	return null;
};

const getHlsSupport = () => {
	const hlsSupport = Hls.isSupported();
	const testVideoElement = document.createElement('video');
	const hasNativeHLSSupport = testVideoElement.canPlayType('application/vnd.apple.mpegurl');
	if (hlsSupport && hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE_AND_MSE;
	}
	if (hlsSupport) {
		return HLS_SUPPORT.SUPPORTED_MSE;
	}
	if (hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE;
	}
	return HLS_SUPPORT.UNSUPPORTED;
};

const getAudioTrackListSupport = () => {
	const testVideoElement = document.createElement('video');
	return testVideoElement.audioTracks !== undefined;
};

export default {
	getSeekPosition,
	seek,
	load,
	getHlsSupport,
	getAudioTrackListSupport,
};
